<template>
    <v-app>
        <v-img
            :src="backgroundImage"
            class="background-image"
            height="100vh"
            width="100vw"
        >
            <template v-slot:placeholder>
                <v-row
                    align="center"
                    class="fill-height ma-0"
                    justify="center"
                >
                    <v-progress-circular
                        color="primary lighten-5"
                        indeterminate
                    ></v-progress-circular>
                </v-row>
            </template>
        </v-img>
        <v-card
            class="mx-auto mt-sm-10"
            width="400"
        >
            <v-card-title class="flex-column justify-center">
                <h1 class="pt-9">ERAF SOLUTIONS</h1>
                <!--<Logo
                    class="mx-auto pt-5"
                    width="61%"
                />-->
            </v-card-title>
            <v-card-text
                class="mt-5"
                v-show="message"
            >
                <v-alert
                    border="left"
                    dense
                    text
                    type="error"
                >{{message}}</v-alert>
            </v-card-text>
            <v-card-text>
                <v-form
                    @submit.prevent="submitLogin"
                    id="login-form"
                    ref="loginForm"
                    v-model="isValid"
                >
                    <v-text-field
                        :disabled="loading"
                        :rules="[v => !!v || 'Username is required']"
                        autocomplete="new"
                        label="Username"
                        prepend-icon="mdi-account-circle-outline"
                        v-model="user.username"
                    />
                    <v-text-field
                        :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                        :disabled="loading"
                        :rules="[v => !!v || 'Password is required']"
                        :type="showPassword? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        autocomplete="new"
                        label="Password"
                        prepend-icon="mdi-lock-outline"
                        v-model="user.password"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    :loading="loading"
                    @click.prevent="submitLogin"
                    class="text-none"
                    color="primary"
                    form="login-form"
                    text
                    type="submit"
                >Sign in</v-btn>
            </v-card-actions>
            <!--<Logo width="100%"/>-->
        </v-card>
    </v-app>
</template>

<script>
import UserCredentials from "../models/UserCredentials.model";
//import Logo from "../components/AcciLogo.vue";
import road1 from "../assets/backgrounds/road1.jpg";
import road2 from "../assets/backgrounds/road2.jpg";
import road3 from "../assets/backgrounds/road3.jpg";
import road4 from "../assets/backgrounds/road4.jpg";

export default {
    name: "Login",
    data: () => ({
        user: new UserCredentials("", "", ""),
        backgroundImages: [road1, road2, road3, road4],
        showPassword: false,
        loading: false,
        isValid: null,
        message: null
    }),

    components: {
        //Logo
        //
    },

    computed: {
        backgroundImage: function() {
            return this.backgroundImages[
                Math.floor(Math.random() * this.backgroundImages.length)
            ];
        }
    },
    methods: {
        validate() {
            this.$refs.loginForm.validate();
        },
        submitLogin() {
            this.validate();
            if (this.isValid) {
                this.loading = true;
                this.$store
                    .dispatch("authentication/login", this.user)
                    .then(
                        token => {
                            if (token) this.$router.push("/");
                            else this.message = "Invalid username or password.";
                        },
                        error => {
                            this.loading = false;
                            this.message =
                                (error.response && error.response.data) ||
                                error.message ||
                                error.toString();
                        }
                    )
                    .finally(() => (this.loading = false));
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.background-image {
    position: fixed;
}
</style>